import scrollSpy from "simple-scrollspy";
import Notices from "./Notices";
import $ from "jquery";

export default class ProductFunctions {
	constructor() {
		this.jsVariationRadio = document.querySelectorAll(".jsVariationRadio");
		this.jsVariationRadioMore = document.querySelectorAll(".jsVariationRadioMore");
		this.jsVariationPrice = document.querySelectorAll(".jsVariationPrice");
		this.jsVariationId = document.querySelector(".jsVariationId");
		this.jsAddToCartWrapper = document.querySelector(".jsAddToCartWrapper");

		this.qtyInputs = document.querySelectorAll(".quantity");
		this.jsQuantity = document.querySelector(".quantity");

		this.notices = new Notices();
		this.initializeScrollSpy();
		this.events();
	}

	events() {
		if (this.jsVariationRadio) {
			this.jsVariationRadio.forEach((radio) => {
				radio.addEventListener("change", this.changeVariation.bind(this));
			});
		}

		if (this.jsVariationRadioMore) {
			this.jsVariationRadioMore.forEach((btn) => {
				btn.addEventListener("click", this.showAllVariations.bind(this));
			});
		}

		$(".variations_form").on("show_variation", this.handleVariationChanges.bind(this));

		$(".variations_form").on("reset_data", this.handleResetData.bind(this));

		$(".single_variation_wrap").on("show_variation", this.handleVariationsChanges.bind(this));

		this.qtyInputs.forEach((btn) => {
			let plus = btn.querySelector(".jsQuantityPlusBtn");
			let minus = btn.querySelector(".jsQuantityMinusBtn");
			let value = btn.querySelector(".qty");

			if (plus && minus) {
				plus.addEventListener("click", () => this.changeQuantity(value, 1));
				minus.addEventListener("click", () => this.changeQuantity(value, -1));
			}
		});
	}

	initializeScrollSpy() {
		const options = {
			sectionClass: ".jsProductSection",
			menuActiveTarget: ".jsAnchorLink",
			offset: 225,
		};

		const anchorMenuElem = document.querySelector(".jsAnchorMenu");

		if (anchorMenuElem) {
			scrollSpy(anchorMenuElem, options);
		}
	}

	changeVariation(pickedVariation) {
		const jsAttributeSelect = pickedVariation.target.closest(".jsVariationRow").querySelector(".jsAttributeSelect");
		const jsPickedVariation = pickedVariation.target.closest(".jsVariationRow").querySelector(".jsPickedVariation");
		const jsVariationInputName = pickedVariation.target
			.closest(".jsVariationRadioWrap")
			.querySelector(".jsVariationInputName");
		const jsClickedVariationValue = pickedVariation.target
			.closest(".jsVariationRadioWrap")
			.querySelector(".jsVariationRadio").value;

		jsAttributeSelect.value = pickedVariation.target.value;
		jsPickedVariation.innerHTML = jsVariationInputName.innerHTML;

		$(jsAttributeSelect).trigger("change");
	}

	showAllVariations(event) {
		event.preventDefault();

		const jsVariationRadios = event.target.closest(".jsVariationRow").querySelectorAll(".jsVariationRadioWrap");

		event.target.closest(".jsVariationRadioMoreWrap").classList.add("wc-product__radios__radio--hidden");

		jsVariationRadios.forEach((radio) => {
			radio.classList.remove("wc-product__radios__radio--hidden");
		});
	}

	handleResetData() {
		if (this.jsVariationPrice) {
			this.jsVariationPrice.forEach((price) => {
				price.classList.add("is-hidden");
			});
		}
	}

	handleVariationChanges(event, variation) {
		if (this.jsVariationPrice) {
			this.jsVariationPrice.forEach((priceHTML) => {
				priceHTML.innerHTML = variation.price_html;
				priceHTML.classList.remove("is-hidden");
			});
		}

		if (this.jsVariationId) {
			this.jsVariationId.value = variation.variation_id;
		}

		if (this.jsVariationRadio) {
			this.jsVariationRadio.forEach((radio) => {
				if (!radio.checked) return;

				const jsPickedVariation = radio.closest(".jsVariationRow").querySelector(".jsPickedVariation");
				const jsVariationInputName = radio.closest(".jsVariationRadioWrap").querySelector(".jsVariationInputName");
				const jsClickedVariationValue = radio.closest(".jsVariationRadioWrap").querySelector(".jsVariationRadio").value;

				jsPickedVariation.innerHTML = jsVariationInputName.innerHTML;
			});
		}

		if (variation.is_in_stock) {
			this.jsAddToCartWrapper.classList.remove("wc-product__variation-add-to-cart--hidden");
			this.jsQuantity.classList.remove("quantity--hidden");
		} else {
			this.jsAddToCartWrapper.classList.add("wc-product__variation-add-to-cart--hidden");
			this.jsQuantity.classList.add("quantity--hidden");

			if (this.jsVariationPrice) {
				this.jsVariationPrice.forEach((priceHTML) => {
					priceHTML.classList.add("is-hidden");
				});
			}
		}

		setTimeout(function () {
			const imageId = document.querySelector(".jsVariableProductForm").getAttribute("current-image");

			if (imageId) {
				let image = document.querySelector("li[data-id='" + imageId + "']");
				if (image) {
					image.click();
				}
			}
		}, 500);
	}

	changeQuantity(element, value) {
		if (document.body.classList.contains("woocommerce-cart")) return;

		const qty = element;
		if (!qty.value) {
			qty.value = 0;
		}

		let qtyValue = parseInt(qty.value, 10);

		if (qtyValue + value <= 0) {
			qtyValue = 0;
		} else {
			qtyValue += value;
		}

		qty.value = qtyValue;
	}

	handleVariationsChanges(event, variation) {}

	createNotice(type, element = null, value = 0, attribute = null) {
		const myFormData = new FormData();
		myFormData.append("security", window.global.security);
		myFormData.append("type", type);
		myFormData.append("element", element);
		myFormData.append("value", value);
		myFormData.append("attribute", attribute);

		fetch(window.global.ajax_url + "?action=createNotice", {
			method: "POST",
			mode: "cors",
			cache: "no-cache",
			credentials: "same-origin",
			redirect: "follow",
			referrerPolicy: "no-referrer",
			body: myFormData,
		})
			.then((resp) => resp.json())
			.then((res) => {
				this.notices.addNotices(res.data.notices, 10000);
			});
	}
}
